
  import React, { useMemo, useEffect, useCallback, useState } from "react";
  import {
    Modal,
    Popover,
    Button,
    Form,
    Input,
  } from "antd";
  import { List, Avatar } from 'antd';

  import styles from "./SelectOrdination.module.css";
  import { showApiErrors } from "../utils/showApiErrors";
  
  import { useContext } from "react";
  import { OrdinationsAndCountriesContext } from "../contexts/ordinationsAndCountriesContext";
  
  export const ModalChoseOrdination = ({
    onCloseModal,
  }) => {
    const { ordinationId, setOrdinationId,ordinations,setSelectedOrdinationId } = useContext(OrdinationsAndCountriesContext);
    const [loading, setLoading] = useState(false);

   
  return (
    <Modal
      title={"Izaberite ordinaciju"}
      closable={false}
      keyboard={false}
      visible={ordinationId === 0 ? true : false}
      
      footer={[

      ]}
      width={600}
    >
     
    <div className={styles.headingActions}>
        <List
    itemLayout="horizontal"
    dataSource={ordinations}
    renderItem={item => (
      <List.Item className={styles.SelectOrdinationList} onClick={()=>{
        setSelectedOrdinationId(item.id);
      }}>
        <List.Item.Meta
          avatar={<Avatar src={item.image}/>}
          title={<span>{item.name}</span>}
        />
      </List.Item>
    )}
  />
    </div>
      </Modal>
  );
};
